// extracted by mini-css-extract-plugin
module.exports = {"item":"pwgAP","image":"pOilt","name":"fV88N","remove":"DEPoL","selectors":"CsCf5","quantity":"oFXED","quantity-btn":"B2wlF"};